<mat-toolbar class="subheader mat-elevation-z1" [class.hidden]="isMobile && !showActions">
  <app-breadcrumb *ngIf="!isMobile"></app-breadcrumb>
  <div *ngIf="isMobile" class="spacer"></div>
  <app-topbar-actions></app-topbar-actions>
</mat-toolbar>